module.exports = __webpack_public_path__ + "img/04.edd72195.jpg";